import { COLORS_MAP_TO_VALUES } from '../../constants';
import { Color, Kind, ThemedColor } from '../../types';

export const isThemedColor = (color: Color, theme: Kind): color is ThemedColor => Boolean(
    COLORS_MAP_TO_VALUES[color as ThemedColor][theme]
);
